<template>
    <div class="x-field">
        <div class="x-input" :class="{'x-input-error': !!error}">
            <label class="x-label" :class="labelClass" v-if="!!label">{{ label }}
                <slot name="label"></slot>
                <el-tooltip :content="tooltipContent"
                            effect="dark"
                            placement="top-end"
                            v-if="!!tooltipContent">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </label>
            <el-time-select :value="value"
                            :picker-options="{
                                start: hourStart,
                                step: hourStep,
                                end: hourEnd
                              }"
                            :class="{'x-input-readonly': readonly}"
                            :clearable="clearable"
                            :readonly="readonly"
                            @input="handleInput($event)"></el-time-select>
            <small class="x-label-error" v-text="textError"></small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'XTimePicker',
    props: {
        value: {
            default: ''
        },
        label: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        error: {
            default: null,
        },
        hourStart: {
            type: String,
            default: '00:00',
        },
        hourEnd: {
            type: String,
            default: '24:00',
        },
        hourStep: {
            type: String,
            default: '00:15',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        tooltipContent: {
            type: String,
            default: null,
        },
        labelClass: {
            type: String,
            default: null,
        },
    },
    data() {
        return {}
    },
    computed: {
        textError() {
            if (!_.isNull(this.error)) {
                return this.error[0];
            }
            return '';
        }
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
        getValueFormat() {
            if (this.type === 'date') {
                return 'yyyy-MM-dd';
            }
            if (this.type === 'datetime') {
                return 'yyyy-MM-dd HH:mm:ss';
            }
            if (this.type === 'month') {
                return 'yyyy-MM';
            }
        },
        getFormat() {
            if (this.type === 'date') {
                return 'dd/MM/yyyy';
            }
            if (this.type === 'datetime') {
                return 'dd/MM/yyyy HH:mm:ss';
            }
            return '';
            // return this.type === 'date' ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm:ss';
        }
    }
}
</script>
